export default __webpack_public_path__ + "static/media/delete.e04aee0a.svg";